import './index.css'
import React from 'react';
import SimpleEditor from '../common/SimpleEditor';
import { AreaForm } from '../../models/area.model';


interface DescriptionProps {
  action: string;
  areaForm: AreaForm;
  handleChange?: (e: any) => void
}

const Description: React.FC<DescriptionProps> = ({ action, areaForm, handleChange }) => {

  return (
    <React.Fragment>
      <div className='area-form-section'>
        <div className='area-form-section-title'>
          <p>Descripción</p>
        </div>

        <div className='area-form-section-item__desc'>
          <SimpleEditor
            name='description'
            value={areaForm.description}
            handleChange={handleChange}
            disabled={action === 'view'}
          />
        </div>

      </div>
    </React.Fragment>
  );
}

export default Description;